import React, { useState, useEffect } from 'react';

const Carousel1 = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        "/gallery/gallery4.jpg",
        "/gallery/gallery5.webp",
        "/gallery/gallery6.webp",
        "/gallery/gallery7.webp",

    ];

    const handleSlideTo = (index) => {
        setActiveIndex(index);
    };

    const handlePrev = () => {
        setActiveIndex((prevIndex) => (prevIndex === 0 ? items.length - 1 : prevIndex - 1));
    };

    const handleNext = () => {
        setActiveIndex((prevIndex) => (prevIndex === items.length - 1 ? 0 : prevIndex + 1));
    };

    // useEffect(() => {
    //     const interval = setInterval(handleNext, 3000); // Auto slide every 3 seconds
    //     return () => clearInterval(interval); // Cleanup on unmount
    // }, []);

    return (
        <div className="relative w-full" data-carousel="slide">
            <div className="relative h-56 overflow-hidden rounded-lg md:h-96">
                {items.map((item, index) => (
                    <div
                        key={index}
                        className={`duration-700 ease-in-out ${index === activeIndex ? '' : 'hidden'
                            }`}
                        data-carousel-item
                    >
                        <img
                            src={item}
                            className="absolute block px-4 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                            alt={`Slide ${index + 1}`}
                        />
                    </div>
                ))}
            </div>

            <div className="absolute z-30 flex space-x-3 -translate-x-1/2 bottom-5 left-1/2">
                {items.map((_, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`w-3 h-3 rounded-full ${index === activeIndex ? 'bg-blue-500' : 'bg-gray-300'
                            }`}
                        aria-current={index === activeIndex ? 'true' : 'false'}
                        aria-label={`Slide ${index + 1}`}
                        data-carousel-slide-to={index}
                        onClick={() => handleSlideTo(index)}
                    ></button>
                ))}
            </div>

            <button
                type="button"
                className="absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                data-carousel-prev
                onClick={handlePrev}
            >
                <svg
                    className="w-6 h-6 text-white group-hover:text-blue-500"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path d="M19 12H6M12 5l-7 7 7 7"></path>
                </svg>
            </button>

            <button
                type="button"
                className="absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                data-carousel-next
                onClick={handleNext}
            >
                <svg
                    className="w-6 h-6 text-white group-hover:text-blue-500"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path d="M5 12h13M12 5l7 7-7 7"></path>
                </svg>
            </button>
        </div>
    );
};

export default Carousel1;
